import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"],
  _excluded2 = ["data"],
  _excluded3 = ["data"],
  _excluded4 = ["data"],
  _excluded5 = ["data"],
  _excluded6 = ["data"],
  _excluded7 = ["data"],
  _excluded8 = ["data"],
  _excluded9 = ["data"],
  _excluded10 = ["data"],
  _excluded11 = ["data"],
  _excluded12 = ["data"],
  _excluded13 = ["data"],
  _excluded14 = ["data"],
  _excluded15 = ["data"],
  _excluded16 = ["data"],
  _excluded17 = ["data"],
  _excluded18 = ["data"],
  _excluded19 = ["data"],
  _excluded20 = ["data"],
  _excluded21 = ["data"],
  _excluded22 = ["data"],
  _excluded23 = ["data"],
  _excluded24 = ["data"],
  _excluded25 = ["data"],
  _excluded26 = ["data"],
  _excluded27 = ["data"],
  _excluded28 = ["data"],
  _excluded29 = ["data"],
  _excluded30 = ["data"],
  _excluded31 = ["data"],
  _excluded32 = ["data"],
  _excluded33 = ["data"],
  _excluded34 = ["data"],
  _excluded35 = ["data"],
  _excluded36 = ["data"],
  _excluded37 = ["data"],
  _excluded38 = ["data"],
  _excluded39 = ["data"],
  _excluded40 = ["data"],
  _excluded41 = ["data"],
  _excluded42 = ["data"],
  _excluded43 = ["data"],
  _excluded44 = ["data"],
  _excluded45 = ["data"],
  _excluded46 = ["data"],
  _excluded47 = ["data"],
  _excluded48 = ["data"],
  _excluded49 = ["data"],
  _excluded50 = ["data"],
  _excluded51 = ["data"],
  _excluded52 = ["data"],
  _excluded53 = ["data"],
  _excluded54 = ["data"],
  _excluded55 = ["data"],
  _excluded56 = ["data"],
  _excluded57 = ["data"],
  _excluded58 = ["data"],
  _excluded59 = ["data"],
  _excluded60 = ["data"],
  _excluded61 = ["data"],
  _excluded62 = ["data"],
  _excluded63 = ["data"],
  _excluded64 = ["data"],
  _excluded65 = ["data"],
  _excluded66 = ["data"],
  _excluded67 = ["data"],
  _excluded68 = ["data"],
  _excluded69 = ["data"],
  _excluded70 = ["data"],
  _excluded71 = ["data"],
  _excluded72 = ["data"],
  _excluded73 = ["data"],
  _excluded74 = ["data"],
  _excluded75 = ["data"],
  _excluded76 = ["data"],
  _excluded77 = ["data"],
  _excluded78 = ["data"],
  _excluded79 = ["data"],
  _excluded80 = ["data"],
  _excluded81 = ["data"],
  _excluded82 = ["data"],
  _excluded83 = ["data"],
  _excluded84 = ["data"],
  _excluded85 = ["data"];
/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import { useQuery, useLazyQuery, useSuspenseQuery, useMutation } from 'data-fetching-client';
import * as Queries from './PublicProductRpc.dfc.new';
export function useGetProductsQuery(options) {
  const _useQuery = useQuery(Queries.GET_PRODUCTS_QUERY, options),
    {
      data
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getProducts: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetProductsLazyQuery(options) {
  const [getter, _ref] = useLazyQuery(Queries.GET_PRODUCTS_QUERY, options);
  const {
      data
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getProducts: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetProductsSuspenseQuery(options) {
  const _useSuspenseQuery = useSuspenseQuery(Queries.GET_PRODUCTS_QUERY, options),
    {
      data
    } = _useSuspenseQuery,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery, _excluded3);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getProducts: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductsV2Query(options) {
  const _useQuery2 = useQuery(Queries.GET_PUBLIC_PRODUCTS_V2_QUERY, options),
    {
      data
    } = _useQuery2,
    rest = _objectWithoutPropertiesLoose(_useQuery2, _excluded4);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductsV2LazyQuery(options) {
  const [getter, _ref2] = useLazyQuery(Queries.GET_PUBLIC_PRODUCTS_V2_QUERY, options);
  const {
      data
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded5);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicProductsV2SuspenseQuery(options) {
  const _useSuspenseQuery2 = useSuspenseQuery(Queries.GET_PUBLIC_PRODUCTS_V2_QUERY, options),
    {
      data
    } = _useSuspenseQuery2,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery2, _excluded6);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetBundleMutation(options) {
  const [getter, _ref3] = useMutation(Queries.GET_BUNDLE_MUTATION, options);
  const {
      data
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded7);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getBundle: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetAddOnsQuery(options) {
  const _useQuery3 = useQuery(Queries.GET_ADD_ONS_QUERY, options),
    {
      data
    } = _useQuery3,
    rest = _objectWithoutPropertiesLoose(_useQuery3, _excluded8);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAddOns: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAddOnsLazyQuery(options) {
  const [getter, _ref4] = useLazyQuery(Queries.GET_ADD_ONS_QUERY, options);
  const {
      data
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded9);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAddOns: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetAddOnsSuspenseQuery(options) {
  const _useSuspenseQuery3 = useSuspenseQuery(Queries.GET_ADD_ONS_QUERY, options),
    {
      data
    } = _useSuspenseQuery3,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery3, _excluded10);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAddOns: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicAddOnsV2Query(options) {
  const _useQuery4 = useQuery(Queries.GET_PUBLIC_ADD_ONS_V2_QUERY, options),
    {
      data
    } = _useQuery4,
    rest = _objectWithoutPropertiesLoose(_useQuery4, _excluded11);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicAddOnsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicAddOnsV2LazyQuery(options) {
  const [getter, _ref5] = useLazyQuery(Queries.GET_PUBLIC_ADD_ONS_V2_QUERY, options);
  const {
      data
    } = _ref5,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded12);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicAddOnsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicAddOnsV2SuspenseQuery(options) {
  const _useSuspenseQuery4 = useSuspenseQuery(Queries.GET_PUBLIC_ADD_ONS_V2_QUERY, options),
    {
      data
    } = _useSuspenseQuery4,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery4, _excluded13);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicAddOnsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetGrowthPurchaseOptionsQuery(options) {
  const _useQuery5 = useQuery(Queries.GET_GROWTH_PURCHASE_OPTIONS_QUERY, options),
    {
      data
    } = _useQuery5,
    rest = _objectWithoutPropertiesLoose(_useQuery5, _excluded14);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getGrowthPurchaseOptions: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetGrowthPurchaseOptionsLazyQuery(options) {
  const [getter, _ref6] = useLazyQuery(Queries.GET_GROWTH_PURCHASE_OPTIONS_QUERY, options);
  const {
      data
    } = _ref6,
    rest = _objectWithoutPropertiesLoose(_ref6, _excluded15);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getGrowthPurchaseOptions: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetGrowthPurchaseOptionsSuspenseQuery(options) {
  const _useSuspenseQuery5 = useSuspenseQuery(Queries.GET_GROWTH_PURCHASE_OPTIONS_QUERY, options),
    {
      data
    } = _useSuspenseQuery5,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery5, _excluded16);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getGrowthPurchaseOptions: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicGrowthPurchaseOptionsV2Query(options) {
  const _useQuery6 = useQuery(Queries.GET_PUBLIC_GROWTH_PURCHASE_OPTIONS_V2_QUERY, options),
    {
      data
    } = _useQuery6,
    rest = _objectWithoutPropertiesLoose(_useQuery6, _excluded17);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicGrowthPurchaseOptionsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicGrowthPurchaseOptionsV2LazyQuery(options) {
  const [getter, _ref7] = useLazyQuery(Queries.GET_PUBLIC_GROWTH_PURCHASE_OPTIONS_V2_QUERY, options);
  const {
      data
    } = _ref7,
    rest = _objectWithoutPropertiesLoose(_ref7, _excluded18);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicGrowthPurchaseOptionsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicGrowthPurchaseOptionsV2SuspenseQuery(options) {
  const _useSuspenseQuery6 = useSuspenseQuery(Queries.GET_PUBLIC_GROWTH_PURCHASE_OPTIONS_V2_QUERY, options),
    {
      data
    } = _useSuspenseQuery6,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery6, _excluded19);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicGrowthPurchaseOptionsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetGrowthPurchaseOptionsUsingCombinedTermsQuery(options) {
  const _useQuery7 = useQuery(Queries.GET_GROWTH_PURCHASE_OPTIONS_USING_COMBINED_TERMS_QUERY, options),
    {
      data
    } = _useQuery7,
    rest = _objectWithoutPropertiesLoose(_useQuery7, _excluded20);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getGrowthPurchaseOptionsUsingCombinedTerms: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetGrowthPurchaseOptionsUsingCombinedTermsLazyQuery(options) {
  const [getter, _ref8] = useLazyQuery(Queries.GET_GROWTH_PURCHASE_OPTIONS_USING_COMBINED_TERMS_QUERY, options);
  const {
      data
    } = _ref8,
    rest = _objectWithoutPropertiesLoose(_ref8, _excluded21);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getGrowthPurchaseOptionsUsingCombinedTerms: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetGrowthPurchaseOptionsUsingCombinedTermsSuspenseQuery(options) {
  const _useSuspenseQuery7 = useSuspenseQuery(Queries.GET_GROWTH_PURCHASE_OPTIONS_USING_COMBINED_TERMS_QUERY, options),
    {
      data
    } = _useSuspenseQuery7,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery7, _excluded22);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getGrowthPurchaseOptionsUsingCombinedTerms: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicCurrencyResponseQuery(options) {
  const _useQuery8 = useQuery(Queries.GET_PUBLIC_CURRENCY_RESPONSE_QUERY, options),
    {
      data
    } = _useQuery8,
    rest = _objectWithoutPropertiesLoose(_useQuery8, _excluded23);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicCurrencyResponse: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicCurrencyResponseLazyQuery(options) {
  const [getter, _ref9] = useLazyQuery(Queries.GET_PUBLIC_CURRENCY_RESPONSE_QUERY, options);
  const {
      data
    } = _ref9,
    rest = _objectWithoutPropertiesLoose(_ref9, _excluded24);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicCurrencyResponse: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicCurrencyResponseSuspenseQuery(options) {
  const _useSuspenseQuery8 = useSuspenseQuery(Queries.GET_PUBLIC_CURRENCY_RESPONSE_QUERY, options),
    {
      data
    } = _useSuspenseQuery8,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery8, _excluded25);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicCurrencyResponse: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicCurrencyV2Query(options) {
  const _useQuery9 = useQuery(Queries.GET_PUBLIC_CURRENCY_V2_QUERY, options),
    {
      data
    } = _useQuery9,
    rest = _objectWithoutPropertiesLoose(_useQuery9, _excluded26);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicCurrencyV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicCurrencyV2LazyQuery(options) {
  const [getter, _ref10] = useLazyQuery(Queries.GET_PUBLIC_CURRENCY_V2_QUERY, options);
  const {
      data
    } = _ref10,
    rest = _objectWithoutPropertiesLoose(_ref10, _excluded27);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicCurrencyV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicCurrencyV2SuspenseQuery(options) {
  const _useSuspenseQuery9 = useSuspenseQuery(Queries.GET_PUBLIC_CURRENCY_V2_QUERY, options),
    {
      data
    } = _useSuspenseQuery9,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery9, _excluded28);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicCurrencyV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicPhoneNumberQuery(options) {
  const _useQuery10 = useQuery(Queries.GET_PUBLIC_PHONE_NUMBER_QUERY, options),
    {
      data
    } = _useQuery10,
    rest = _objectWithoutPropertiesLoose(_useQuery10, _excluded29);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicPhoneNumber: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicPhoneNumberLazyQuery(options) {
  const [getter, _ref11] = useLazyQuery(Queries.GET_PUBLIC_PHONE_NUMBER_QUERY, options);
  const {
      data
    } = _ref11,
    rest = _objectWithoutPropertiesLoose(_ref11, _excluded30);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicPhoneNumber: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicPhoneNumberSuspenseQuery(options) {
  const _useSuspenseQuery10 = useSuspenseQuery(Queries.GET_PUBLIC_PHONE_NUMBER_QUERY, options),
    {
      data
    } = _useSuspenseQuery10,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery10, _excluded31);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicPhoneNumber: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicPhoneNumberV2Query(options) {
  const _useQuery11 = useQuery(Queries.GET_PUBLIC_PHONE_NUMBER_V2_QUERY, options),
    {
      data
    } = _useQuery11,
    rest = _objectWithoutPropertiesLoose(_useQuery11, _excluded32);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicPhoneNumberV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicPhoneNumberV2LazyQuery(options) {
  const [getter, _ref12] = useLazyQuery(Queries.GET_PUBLIC_PHONE_NUMBER_V2_QUERY, options);
  const {
      data
    } = _ref12,
    rest = _objectWithoutPropertiesLoose(_ref12, _excluded33);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicPhoneNumberV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicPhoneNumberV2SuspenseQuery(options) {
  const _useSuspenseQuery11 = useSuspenseQuery(Queries.GET_PUBLIC_PHONE_NUMBER_V2_QUERY, options),
    {
      data
    } = _useSuspenseQuery11,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery11, _excluded34);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicPhoneNumberV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicFeatureFlagsQuery(options) {
  const _useQuery12 = useQuery(Queries.GET_PUBLIC_FEATURE_FLAGS_QUERY, options),
    {
      data
    } = _useQuery12,
    rest = _objectWithoutPropertiesLoose(_useQuery12, _excluded35);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicFeatureFlags: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicFeatureFlagsLazyQuery(options) {
  const [getter, _ref13] = useLazyQuery(Queries.GET_PUBLIC_FEATURE_FLAGS_QUERY, options);
  const {
      data
    } = _ref13,
    rest = _objectWithoutPropertiesLoose(_ref13, _excluded36);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicFeatureFlags: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicFeatureFlagsSuspenseQuery(options) {
  const _useSuspenseQuery12 = useSuspenseQuery(Queries.GET_PUBLIC_FEATURE_FLAGS_QUERY, options),
    {
      data
    } = _useSuspenseQuery12,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery12, _excluded37);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicFeatureFlags: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicFeatureFlagsV2Query(options) {
  const _useQuery13 = useQuery(Queries.GET_PUBLIC_FEATURE_FLAGS_V2_QUERY, options),
    {
      data
    } = _useQuery13,
    rest = _objectWithoutPropertiesLoose(_useQuery13, _excluded38);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicFeatureFlagsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicFeatureFlagsV2LazyQuery(options) {
  const [getter, _ref14] = useLazyQuery(Queries.GET_PUBLIC_FEATURE_FLAGS_V2_QUERY, options);
  const {
      data
    } = _ref14,
    rest = _objectWithoutPropertiesLoose(_ref14, _excluded39);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicFeatureFlagsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicFeatureFlagsV2SuspenseQuery(options) {
  const _useSuspenseQuery13 = useSuspenseQuery(Queries.GET_PUBLIC_FEATURE_FLAGS_V2_QUERY, options),
    {
      data
    } = _useSuspenseQuery13,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery13, _excluded40);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicFeatureFlagsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicPricingPageDetailsQuery(options) {
  const _useQuery14 = useQuery(Queries.GET_PUBLIC_PRICING_PAGE_DETAILS_QUERY, options),
    {
      data
    } = _useQuery14,
    rest = _objectWithoutPropertiesLoose(_useQuery14, _excluded41);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicPricingPageDetails: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicPricingPageDetailsLazyQuery(options) {
  const [getter, _ref15] = useLazyQuery(Queries.GET_PUBLIC_PRICING_PAGE_DETAILS_QUERY, options);
  const {
      data
    } = _ref15,
    rest = _objectWithoutPropertiesLoose(_ref15, _excluded42);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicPricingPageDetails: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicPricingPageDetailsSuspenseQuery(options) {
  const _useSuspenseQuery14 = useSuspenseQuery(Queries.GET_PUBLIC_PRICING_PAGE_DETAILS_QUERY, options),
    {
      data
    } = _useSuspenseQuery14,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery14, _excluded43);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicPricingPageDetails: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductUseCasesV2Query(options) {
  const _useQuery15 = useQuery(Queries.GET_PUBLIC_PRODUCT_USE_CASES_V2_QUERY, options),
    {
      data
    } = _useQuery15,
    rest = _objectWithoutPropertiesLoose(_useQuery15, _excluded44);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductUseCasesV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductUseCasesV2LazyQuery(options) {
  const [getter, _ref16] = useLazyQuery(Queries.GET_PUBLIC_PRODUCT_USE_CASES_V2_QUERY, options);
  const {
      data
    } = _ref16,
    rest = _objectWithoutPropertiesLoose(_ref16, _excluded45);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductUseCasesV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicProductUseCasesV2SuspenseQuery(options) {
  const _useSuspenseQuery15 = useSuspenseQuery(Queries.GET_PUBLIC_PRODUCT_USE_CASES_V2_QUERY, options),
    {
      data
    } = _useSuspenseQuery15,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery15, _excluded46);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductUseCasesV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductUseCasesV3Query(options) {
  const _useQuery16 = useQuery(Queries.GET_PUBLIC_PRODUCT_USE_CASES_V3_QUERY, options),
    {
      data
    } = _useQuery16,
    rest = _objectWithoutPropertiesLoose(_useQuery16, _excluded47);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductUseCasesV3: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductUseCasesV3LazyQuery(options) {
  const [getter, _ref17] = useLazyQuery(Queries.GET_PUBLIC_PRODUCT_USE_CASES_V3_QUERY, options);
  const {
      data
    } = _ref17,
    rest = _objectWithoutPropertiesLoose(_ref17, _excluded48);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductUseCasesV3: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicProductUseCasesV3SuspenseQuery(options) {
  const _useSuspenseQuery16 = useSuspenseQuery(Queries.GET_PUBLIC_PRODUCT_USE_CASES_V3_QUERY, options),
    {
      data
    } = _useSuspenseQuery16,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery16, _excluded49);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductUseCasesV3: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductPlanQuery(options) {
  const _useQuery17 = useQuery(Queries.GET_PUBLIC_PRODUCT_PLAN_QUERY, options),
    {
      data
    } = _useQuery17,
    rest = _objectWithoutPropertiesLoose(_useQuery17, _excluded50);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductPlan: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductPlanLazyQuery(options) {
  const [getter, _ref18] = useLazyQuery(Queries.GET_PUBLIC_PRODUCT_PLAN_QUERY, options);
  const {
      data
    } = _ref18,
    rest = _objectWithoutPropertiesLoose(_ref18, _excluded51);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductPlan: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicProductPlanSuspenseQuery(options) {
  const _useSuspenseQuery17 = useSuspenseQuery(Queries.GET_PUBLIC_PRODUCT_PLAN_QUERY, options),
    {
      data
    } = _useSuspenseQuery17,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery17, _excluded52);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductPlan: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductPlanV2Query(options) {
  const _useQuery18 = useQuery(Queries.GET_PUBLIC_PRODUCT_PLAN_V2_QUERY, options),
    {
      data
    } = _useQuery18,
    rest = _objectWithoutPropertiesLoose(_useQuery18, _excluded53);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductPlanV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductPlanV2LazyQuery(options) {
  const [getter, _ref19] = useLazyQuery(Queries.GET_PUBLIC_PRODUCT_PLAN_V2_QUERY, options);
  const {
      data
    } = _ref19,
    rest = _objectWithoutPropertiesLoose(_ref19, _excluded54);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductPlanV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicProductPlanV2SuspenseQuery(options) {
  const _useSuspenseQuery18 = useSuspenseQuery(Queries.GET_PUBLIC_PRODUCT_PLAN_V2_QUERY, options),
    {
      data
    } = _useSuspenseQuery18,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery18, _excluded55);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductPlanV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductBadgesQuery(options) {
  const _useQuery19 = useQuery(Queries.GET_PUBLIC_PRODUCT_BADGES_QUERY, options),
    {
      data
    } = _useQuery19,
    rest = _objectWithoutPropertiesLoose(_useQuery19, _excluded56);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductBadges: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductBadgesLazyQuery(options) {
  const [getter, _ref20] = useLazyQuery(Queries.GET_PUBLIC_PRODUCT_BADGES_QUERY, options);
  const {
      data
    } = _ref20,
    rest = _objectWithoutPropertiesLoose(_ref20, _excluded57);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductBadges: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicProductBadgesSuspenseQuery(options) {
  const _useSuspenseQuery19 = useSuspenseQuery(Queries.GET_PUBLIC_PRODUCT_BADGES_QUERY, options),
    {
      data
    } = _useSuspenseQuery19,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery19, _excluded58);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductBadges: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductTierOptionsQuery(options) {
  const _useQuery20 = useQuery(Queries.GET_PUBLIC_PRODUCT_TIER_OPTIONS_QUERY, options),
    {
      data
    } = _useQuery20,
    rest = _objectWithoutPropertiesLoose(_useQuery20, _excluded59);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductTierOptions: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductTierOptionsLazyQuery(options) {
  const [getter, _ref21] = useLazyQuery(Queries.GET_PUBLIC_PRODUCT_TIER_OPTIONS_QUERY, options);
  const {
      data
    } = _ref21,
    rest = _objectWithoutPropertiesLoose(_ref21, _excluded60);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductTierOptions: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicProductTierOptionsSuspenseQuery(options) {
  const _useSuspenseQuery20 = useSuspenseQuery(Queries.GET_PUBLIC_PRODUCT_TIER_OPTIONS_QUERY, options),
    {
      data
    } = _useSuspenseQuery20,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery20, _excluded61);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductTierOptions: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductTierOptionsV2Query(options) {
  const _useQuery21 = useQuery(Queries.GET_PUBLIC_PRODUCT_TIER_OPTIONS_V2_QUERY, options),
    {
      data
    } = _useQuery21,
    rest = _objectWithoutPropertiesLoose(_useQuery21, _excluded62);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductTierOptionsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductTierOptionsV2LazyQuery(options) {
  const [getter, _ref22] = useLazyQuery(Queries.GET_PUBLIC_PRODUCT_TIER_OPTIONS_V2_QUERY, options);
  const {
      data
    } = _ref22,
    rest = _objectWithoutPropertiesLoose(_ref22, _excluded63);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductTierOptionsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicProductTierOptionsV2SuspenseQuery(options) {
  const _useSuspenseQuery21 = useSuspenseQuery(Queries.GET_PUBLIC_PRODUCT_TIER_OPTIONS_V2_QUERY, options),
    {
      data
    } = _useSuspenseQuery21,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery21, _excluded64);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductTierOptionsV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductConfigurationOptionsQuery(options) {
  const _useQuery22 = useQuery(Queries.GET_PUBLIC_PRODUCT_CONFIGURATION_OPTIONS_QUERY, options),
    {
      data
    } = _useQuery22,
    rest = _objectWithoutPropertiesLoose(_useQuery22, _excluded65);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductConfigurationOptions: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductConfigurationOptionsLazyQuery(options) {
  const [getter, _ref23] = useLazyQuery(Queries.GET_PUBLIC_PRODUCT_CONFIGURATION_OPTIONS_QUERY, options);
  const {
      data
    } = _ref23,
    rest = _objectWithoutPropertiesLoose(_ref23, _excluded66);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductConfigurationOptions: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicProductConfigurationOptionsSuspenseQuery(options) {
  const _useSuspenseQuery22 = useSuspenseQuery(Queries.GET_PUBLIC_PRODUCT_CONFIGURATION_OPTIONS_QUERY, options),
    {
      data
    } = _useSuspenseQuery22,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery22, _excluded67);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductConfigurationOptions: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicCabProductsQuery(options) {
  const _useQuery23 = useQuery(Queries.GET_PUBLIC_CAB_PRODUCTS_QUERY, options),
    {
      data
    } = _useQuery23,
    rest = _objectWithoutPropertiesLoose(_useQuery23, _excluded68);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicCabProducts: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicCabProductsLazyQuery(options) {
  const [getter, _ref24] = useLazyQuery(Queries.GET_PUBLIC_CAB_PRODUCTS_QUERY, options);
  const {
      data
    } = _ref24,
    rest = _objectWithoutPropertiesLoose(_ref24, _excluded69);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicCabProducts: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicCabProductsSuspenseQuery(options) {
  const _useSuspenseQuery23 = useSuspenseQuery(Queries.GET_PUBLIC_CAB_PRODUCTS_QUERY, options),
    {
      data
    } = _useSuspenseQuery23,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery23, _excluded70);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicCabProducts: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useCalculateCartQuery(options) {
  const _useQuery24 = useQuery(Queries.CALCULATE_CART_QUERY, options),
    {
      data
    } = _useQuery24,
    rest = _objectWithoutPropertiesLoose(_useQuery24, _excluded71);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    calculateCart: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useCalculateCartLazyQuery(options) {
  const [getter, _ref25] = useLazyQuery(Queries.CALCULATE_CART_QUERY, options);
  const {
      data
    } = _ref25,
    rest = _objectWithoutPropertiesLoose(_ref25, _excluded72);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    calculateCart: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useCalculateCartSuspenseQuery(options) {
  const _useSuspenseQuery24 = useSuspenseQuery(Queries.CALCULATE_CART_QUERY, options),
    {
      data
    } = _useSuspenseQuery24,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery24, _excluded73);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    calculateCart: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductGroupsQuery(options) {
  const _useQuery25 = useQuery(Queries.GET_PUBLIC_PRODUCT_GROUPS_QUERY, options),
    {
      data
    } = _useQuery25,
    rest = _objectWithoutPropertiesLoose(_useQuery25, _excluded74);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductGroups: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicProductGroupsLazyQuery(options) {
  const [getter, _ref26] = useLazyQuery(Queries.GET_PUBLIC_PRODUCT_GROUPS_QUERY, options);
  const {
      data
    } = _ref26,
    rest = _objectWithoutPropertiesLoose(_ref26, _excluded75);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductGroups: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicProductGroupsSuspenseQuery(options) {
  const _useSuspenseQuery25 = useSuspenseQuery(Queries.GET_PUBLIC_PRODUCT_GROUPS_QUERY, options),
    {
      data
    } = _useSuspenseQuery25,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery25, _excluded76);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicProductGroups: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetCreditActionsQuery(options) {
  const _useQuery26 = useQuery(Queries.GET_CREDIT_ACTIONS_QUERY, options),
    {
      data
    } = _useQuery26,
    rest = _objectWithoutPropertiesLoose(_useQuery26, _excluded77);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getCreditActions: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetCreditActionsLazyQuery(options) {
  const [getter, _ref27] = useLazyQuery(Queries.GET_CREDIT_ACTIONS_QUERY, options);
  const {
      data
    } = _ref27,
    rest = _objectWithoutPropertiesLoose(_ref27, _excluded78);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getCreditActions: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetCreditActionsSuspenseQuery(options) {
  const _useSuspenseQuery26 = useSuspenseQuery(Queries.GET_CREDIT_ACTIONS_QUERY, options),
    {
      data
    } = _useSuspenseQuery26,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery26, _excluded79);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getCreditActions: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicRecommendationsQuery(options) {
  const _useQuery27 = useQuery(Queries.GET_PUBLIC_RECOMMENDATIONS_QUERY, options),
    {
      data
    } = _useQuery27,
    rest = _objectWithoutPropertiesLoose(_useQuery27, _excluded80);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicRecommendations: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetPublicRecommendationsLazyQuery(options) {
  const [getter, _ref28] = useLazyQuery(Queries.GET_PUBLIC_RECOMMENDATIONS_QUERY, options);
  const {
      data
    } = _ref28,
    rest = _objectWithoutPropertiesLoose(_ref28, _excluded81);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicRecommendations: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetPublicRecommendationsSuspenseQuery(options) {
  const _useSuspenseQuery27 = useSuspenseQuery(Queries.GET_PUBLIC_RECOMMENDATIONS_QUERY, options),
    {
      data
    } = _useSuspenseQuery27,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery27, _excluded82);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getPublicRecommendations: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useProcessPublicRecommendationMutation(options) {
  const [getter, _ref29] = useMutation(Queries.PROCESS_PUBLIC_RECOMMENDATION_MUTATION, options);
  const {
      data
    } = _ref29,
    rest = _objectWithoutPropertiesLoose(_ref29, _excluded83);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    processPublicRecommendation: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useProcessManualPublicRecommendationMutation(options) {
  const [getter, _ref30] = useMutation(Queries.PROCESS_MANUAL_PUBLIC_RECOMMENDATION_MUTATION, options);
  const {
      data
    } = _ref30,
    rest = _objectWithoutPropertiesLoose(_ref30, _excluded84);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    processManualPublicRecommendation: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useSetPublicRecommendationFeedbackMutation(options) {
  const [getter, _ref31] = useMutation(Queries.SET_PUBLIC_RECOMMENDATION_FEEDBACK_MUTATION, options);
  const {
      data
    } = _ref31,
    rest = _objectWithoutPropertiesLoose(_ref31, _excluded85);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    setPublicRecommendationFeedback: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}